import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { router } from "./router";
import "./index.css";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}

// --- PWA_FEATURE_START ---
// PWA head tags (injected via JS to avoid Bun bundler resolution)
function addLink(rel: string, href: string, attrs?: Record<string, string>) {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  if (attrs) for (const [k, v] of Object.entries(attrs)) link.setAttribute(k, v);
  document.head.appendChild(link);
}
addLink("manifest", "/manifest.json");
addLink("apple-touch-icon", "/icons/icon-192.png");
addLink("icon", "/icons/icon.svg", { type: "image/svg+xml" });

// Service Worker Registration (production only — SWs cache aggressively and break HMR in dev)
if (process.env.NODE_ENV !== "production" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    for (const reg of regs) reg.unregister();
  });
} else if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Check for updates periodically (every 60 minutes)
        setInterval(() => reg.update(), 60 * 60 * 1000);

        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;

          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "activated" && navigator.serviceWorker.controller) {
              // New version available — notify user
              if (confirm("A new version is available. Reload?")) {
                window.location.reload();
              }
            }
          });
        });
      })
      .catch((err) => console.error("SW registration failed:", err));
  });
}
// --- PWA_FEATURE_END ---
